import { useRef } from "react";

import debounce from "lodash.debounce";

export const useDebounce = (...params: Parameters<typeof debounce>) => {
  const ref = useRef(debounce(...params));
  return ref.current;
};
